import DOMPurify from 'dompurify';
import { safeExternalM2MUrl } from './m2mApi';

export const M2M_REPORT_CSP = "default-src 'none'; base-uri 'none'; form-action 'none'; img-src https: data:; style-src 'unsafe-inline' https:; font-src https: data:";

/** The sandbox and this document's CSP also apply to styles/resources preserved by sanitization. */
export function buildM2MReportDocument(html: string): string {
  const sanitized = DOMPurify.sanitize(html, {
    WHOLE_DOCUMENT: true,
    ADD_TAGS: ['style', 'link'],
    FORBID_TAGS: ['script', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'textarea', 'select', 'base', 'meta'],
    FORBID_ATTR: ['srcdoc', 'ping'],
  });
  const doc = new DOMParser().parseFromString(sanitized, 'text/html');
  doc.querySelectorAll('a').forEach(link => {
    const href = link.getAttribute('href') || link.getAttribute('xlink:href') || '';
    link.removeAttribute('xlink:href');
    if (href.startsWith('#')) { link.setAttribute('href', href); return; }
    const safe = safeExternalM2MUrl(href);
    if (!safe) { link.removeAttribute('href'); return; }
    // SVG anchors have read-only href properties; attributes work for both HTML and SVG.
    link.setAttribute('href', safe);
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
    link.setAttribute('referrerpolicy', 'no-referrer');
  });
  doc.querySelectorAll('link').forEach(link => {
    if (link.rel !== 'stylesheet' || !safeExternalM2MUrl(link.getAttribute('href'))) link.remove();
    else link.referrerPolicy = 'no-referrer';
  });
  const csp = doc.createElement('meta');
  csp.httpEquiv = 'Content-Security-Policy';
  csp.content = M2M_REPORT_CSP;
  const referrer = doc.createElement('meta');
  referrer.name = 'referrer';
  referrer.content = 'no-referrer';
  doc.head.prepend(csp, referrer);
  return `<!doctype html>\n${doc.documentElement.outerHTML}`;
}
